/**
 * Validates if the given address object contains all required fields.
 * @param {Object} address - The address object to validate.
 * @returns {boolean} Returns `true` if all required fields are present, otherwise `false`.
 */
export const isValidAddress = (address) => {
  return (
    address.street_name &&
    address.street_number &&
    address.zip_code &&
    address.city &&
    address.state &&
    address.country
  );
};
